const q = require('queried');
const on = require('emmy/on');
const { KudaTip } = require('./utils');

// list of tips
q.all('[data-dropdown]').forEach((dropdown) => {
  const tip = new KudaTip(dropdown);

  // initially all dropdowns are hidden in markup
  // so they are not be visible on page load
  dropdown.removeAttribute('hidden');

  const className = dropdown.getAttribute('data-dropdown-container-class');
  if (className) {
    tip.classname = className;
  }

  const position = dropdown.getAttribute('data-dropdown-position') || 'bottom';
  tip.position(position, { auto: false });

  on(dropdown, {
    'tip:hide': () => tip.hide(),
    'tip:reposition': () => tip.reposition(),
  });

  q.all(`[data-dropdown-target="#${dropdown.id}"]`).forEach((target) => {
    on(target, 'click', () => {
      tip.toggle(target);
    });
  });

  if (dropdown.getAttribute('data-dropdown-scroll-hide')) {
    tip.scrollHide();
  }
});

on(document, 'click', (e) => {
  if (e.target.closest('[data-dropdown],[data-dropdown-target]')) return;
  KudaTip.hideAll();
});
